import { get } from "./baseService";

export async function getCountries() {
  const response = await get("countries", true);
  return response;
}

export async function getCountry(code) {
  const response = await get(`countries/${code}`, true);
  return response;
}

export async function getCountryArticles(code) {
  const response = await get(`countries/${code}/articles`, true);
  return response;
}
